import React from "react";
import { steps } from "../../App/Landing/landingContent";
import { Icon } from "./Icon";
import Reveal from "./Reveal";

export default function HowItWorks() {
  return (
    <section id="how" className="bg-white py-14 lg:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-brand">How it works</p>
          <h2 className="display mt-2 text-3xl sm:text-4xl">Get Your Prints in 3 Easy Steps.</h2>
          <p className="mt-2 text-sm text-slate-500">From design to delivery, we make custom printing simple and stress-free.</p>
        </Reveal>

        <ol className="mt-10 grid gap-10 md:grid-cols-3 md:gap-4 items-start">
          {steps.map((s, i) => (
            <Reveal key={s.title} as="li" delay={i * 150} className="relative flex flex-col items-center text-center md:items-start md:text-left">
              <Icon name={s.icon} className="h-20 w-20 text-slate-600" />
              <div className="mt-3 flex items-start gap-3 text-left">
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand text-xs font-bold text-white">{i + 1}</span>
                <div>
                  <h3 className="font-bold">{s.title}</h3>
                  <p className="mt-1 text-sm text-slate-600 leading-relaxed">{s.description}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
